import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'top-exposure-item-placeholder',
  templateUrl: './top-exposure-item-placeholder.component.html',
  styleUrls: ['./top-exposure-item-placeholder.component.scss']
})
export class TopExposureItemPlaceholderComponent implements OnInit {

  @Input() name: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-item-placeholder/top-exposure-item-placeholder.component.ts